import { List, Map } from 'immutable'
import { browserHistory } from 'react-router'

import wopiService from '../services/wopi'

const IS_SENDING_QUESTIONNAIRE = 'admin/questionnaires/SENDING'
export const SENT_INVITATIONS_SUCCESS = 'admin/questionnaires/SENT_INVITATIONS_SUCCESS'
const SEARCH_QUESTIONNAIRES = 'admin/questionnaires/SEARCH'
const FILTER_QUESTIONNAIRES = 'admin/questionnaires/FILTER'
const PAGINATE_QUESTIONNAIRES = 'admin/questionnaires/PAGINATE'
const SET_SENT_INVITATIONS = 'admin/questionnaires/SENT_INVITATIONS'
const SET_INVITATION_ERROR = 'admin/questionnaires/INVITATION_ERROR'
export const DELETE_WOPI = 'admin/questionnaires/DELETE'
const SHOW_ONLY_OWN_QUESTIONNAIRES = 'admin/questionnaires/OWN'
export const NO_MORE_WOPI_CREDITS = 'admin/questionnaires/NO_MORE_WOPI_CREDITS'
const DISMISS_NO_MORE_WOPI_CREDITS = 'admin/questionnaires/DISMISS_NO_MORE_WOPI_CREDITS'

const IS_GENERATING_NO_EMAIL_INVITATIONS = 'admin/questionnaires/IS_GENERATING_NO_EMAIL_INVITATIONS'
export const GENERATING_NO_EMAIL_INVITATIONS_SUCCESS =
  'admin/questionnaires/GENERATING_NO_EMAIL_INVITATIONS_SUCCESS'
const SET_NEW_INVITATION_WOPIS = 'admin/questionnaires/SET_NEW_INVITATION_WOPIS'

const defaultState = Map({
  questionnaireUuid: null,
  questionnaires: null,
  isSendingInvitations: null,
  searchFilters: {},
  pagination: null,
  invitationError: null,
  noMoreWopiCredits: false,
  sentInvitations: List(),
  deletedWopis: List(),
  showOnlyOwnQuestionnaires: true,
  isGeneratingNoEmailInvitations: null,
  newInvitationWopis: List()
})

export default function(state = defaultState, action = undefined) {
  switch (action.type) {
    case IS_SENDING_QUESTIONNAIRE:
      return state.update('isSendingInvitations', sending => action.payload)

    case FILTER_QUESTIONNAIRES:
      return state.update('searchFilters', filters => action.payload)

    case SEARCH_QUESTIONNAIRES:
      return state.update('questionnaires', questionnaires => action.payload)

    case PAGINATE_QUESTIONNAIRES:
      return state.update('pagination', pagination => action.payload)

    case SET_INVITATION_ERROR:
      return state.update('invitationError', invitations => action.payload)

    case SET_SENT_INVITATIONS:
      return state.update('sentInvitations', invitations => action.payload)

    case DELETE_WOPI:
      return state.update('deletedWopis', deletedWopis => deletedWopis.push(action.payload.uuid))

    case SHOW_ONLY_OWN_QUESTIONNAIRES:
      return state.update('showOnlyOwnQuestionnaires', show => action.payload)

    case NO_MORE_WOPI_CREDITS:
      return state.update('noMoreWopiCredits', noMoreWopiCredits => true)

    case DISMISS_NO_MORE_WOPI_CREDITS:
      return state.update('noMoreWopiCredits', noMoreWopiCredits => false)

    case IS_GENERATING_NO_EMAIL_INVITATIONS:
      return state.update('isGeneratingNoEmailInvitations', sending => action.payload)

    case SET_NEW_INVITATION_WOPIS:
      return state.update('newInvitationWopis', links => action.payload)

    default:
      return state
  }
}

export function search(
  organisationId,
  keyword = '',
  filters = {},
  page = 1,
  showOnlyOwnQuestionnaires
) {
  return function d(dispatch) {
    dispatch({ type: FILTER_QUESTIONNAIRES, payload: filters })
    dispatch({ type: SEARCH_QUESTIONNAIRES, payload: null })
    dispatch({ type: PAGINATE_QUESTIONNAIRES, payload: null })

    return wopiService
      .search(organisationId, keyword, filters, page, showOnlyOwnQuestionnaires)
      .then(response => {
        dispatch({ type: SEARCH_QUESTIONNAIRES, payload: List(response.data.results) })
        dispatch({ type: PAGINATE_QUESTIONNAIRES, payload: response.data.pagination })
      })
  }
}

export function invite(
  organisationId,
  recipients,
  title,
  message,
  signature,
  organisation,
  role,
  language
) {
  return function d(dispatch) {
    dispatch({ type: IS_SENDING_QUESTIONNAIRE, payload: true })

    return wopiService
      .invite(organisationId, recipients, title, message, signature, organisation, role, language)
      .then(response => {
        setSentInvitations(recipients)(dispatch)

        dispatch({
          type: SENT_INVITATIONS_SUCCESS,
          payload: {
            response: response.data
          }
        })

        browserHistory.push('/')

        dispatch({ type: IS_SENDING_QUESTIONNAIRE, payload: false })

        setTimeout(() => setSentInvitations()(dispatch), 10000)
      })
      .catch(error => {
        dispatch({ type: IS_SENDING_QUESTIONNAIRE, payload: false })

        if (error && error.response && error.response.status === 409) {
          dispatch({ type: NO_MORE_WOPI_CREDITS })
        } else {
          setInvitationError(error)(dispatch)
        }
      })
  }
}

export function setSentInvitations(recipients) {
  return function d(dispatch) {
    dispatch({ type: SET_SENT_INVITATIONS, payload: List(recipients) })
  }
}

export function setInvitationError(error) {
  return function d(dispatch) {
    dispatch({ type: SET_INVITATION_ERROR, payload: error })
  }
}

export function generateNoEmailInvitations(
  organisationId,
  recipientCount,
  organisation,
  role,
  language
) {
  return function d(dispatch) {
    dispatch({ type: IS_GENERATING_NO_EMAIL_INVITATIONS, payload: true })

    return wopiService
      .generateNoEmailInvitations(organisationId, recipientCount, organisation, role, language)
      .then(response => {
        setNewInvitationWopis(response.data.wopis)(dispatch)

        dispatch({
          type: GENERATING_NO_EMAIL_INVITATIONS_SUCCESS,
          payload: {
            response: response.data
          }
        })

        browserHistory.push('/')

        dispatch({ type: IS_GENERATING_NO_EMAIL_INVITATIONS, payload: false })
      })
      .catch(error => {
        dispatch({ type: IS_GENERATING_NO_EMAIL_INVITATIONS, payload: false })

        if (error && error.response && error.response.status === 409) {
          dispatch({ type: NO_MORE_WOPI_CREDITS })
        } else {
          setInvitationError(error)(dispatch)
        }
      })
  }
}

export function setNewInvitationWopis(wopis) {
  return function d(dispatch) {
    dispatch({ type: SET_NEW_INVITATION_WOPIS, payload: List(wopis) })
  }
}

export function deleteWopi(organisationId, uuid) {
  return dispatch => {
    return wopiService.delete(organisationId, uuid).then(response => {
      dispatch({
        type: DELETE_WOPI,
        payload: {
          uuid,
          response: response.data
        }
      })
    })
  }
}

export function setShowOnlyOwnQuestionnaires(show) {
  return function d(dispatch) {
    dispatch({ type: SHOW_ONLY_OWN_QUESTIONNAIRES, payload: show })
  }
}

export function dismissNoMoreWopiCredits() {
  return dispatch => {
    dispatch({ type: DISMISS_NO_MORE_WOPI_CREDITS })
  }
}



// WEBPACK FOOTER //
// ./src/ducks/questionnaire-admin.js